import { render, staticRenderFns } from "./NotificationsForm.vue?vue&type=template&id=c0e407c8"
import script from "./NotificationsForm.vue?vue&type=script&lang=js"
export * from "./NotificationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports